// A caller could not use a response that checkResponse has already reported, or that never arrived
// because the user left the page. It still fails the caller, but AppSignal ignores it by its message
// (config/appsignal.js), so one blocked request is one report.
export default class AlreadyReportedError extends Error {
  static get message() {
    return "Response already reported as an UnexpectedResponseError";
  }

  constructor() {
    super(AlreadyReportedError.message);
    this.name = "AlreadyReportedError";
  }
}
